<template>
  <div class="container playlist-cards" id="playlist">
    <!-- create new PlayList button  -->
    <div class="text-right"  v-if="$store.getters.getUserSingleConceptsCollection.length>0">
      <button class="btn btn-blue" @click="showCreateNewModal">{{$t('playlist.CreateNewPlaylist')}}</button>
    </div>

   
    <!-- user allocated single concepts -->
    <div class="row justify-content-end">
      <h6 class="main-title col-12">User Single Concept Collection</h6>
      <!-- <b-form-input placeholder ="Press Enter to search" type ="text" v-model="keyWord"  @keydown.enter.native="searchSingleConcept()"></b-form-input>  -->
    </div>

  

    <!-- display allocated single concepts -->
    <div>
      <div v-if="$store.getters.getUserSingleConceptsCollection.length>0" class="row" :options="swiperOptionp3">
        <div class="col-3" v-for="collection in $store.getters.getUserSingleConceptsCollection" :key="collection.contentId">
          
          <!-- individual card -->
          <div class="card-design">
            
            <!-- thumbnail -->
            <div class="card-design__img" v-lazy-container="{ selector: 'img' }">
              <img :data-src="makePath(collection.thumbnail, collection.type)" alt="">
            </div>

            <!-- name, rating, share ,add to playList btn -->
            <div class="card-design__data">
              
              <!-- name of LO -->
              <h3 v-b-tooltip.hover :title="collection.title" class="card-design__data-heading text-truncate no-line"> {{collection.title}}</h3>
              
              <!-- rating section -->
              <div class="ratingText" v-if="instanceName !=='MAHADEMY'">Your Rating</div>
              <div class="rating-ptag"  v-if="instanceName !=='MAHADEMY'" @click="showRating(collection.contentId)">
                <span>                 
                    <star-rating :rating="collection.rating" v-bind:increment="0.5" @rating-selected="setRating" v-bind:max-rating="5" inactive-color="#aaa" active-color="#ffc000" v-bind:star-size="15">
                    </star-rating>  
                </span>
              </div>
              <!-- add to PlayList Button -->
               <!-- <div class="text-center btn-padding">
                <button class="btn btn-green-o" @click="selectCollection(collection)" v-b-modal.addplay>{{$t('playlist.AddToPlaylist')}}</button>
              </div> -->
              <div class="text-center btn-padding">
                <!-- <button class="btn btn-green-o" @click="selectCollection(collection)" v-b-modal.addplay>{{$t('playlist.AddToPlaylist')}}</button> -->
                <button class="btn btn-green-o" @click="selectCollection(collection)">{{$t('playlist.AddToPlaylist')}}</button>
              </div>
            </div>

          </div>
        </div>

      </div>
      <div v-else>
          <div class="noticemsg">
          <br/><span> You have no single concepts</span>
          </div>
      </div>
        <!-- show more button -->
        <div class="text-right" v-if="$store.getters.getUserSingleConceptsCollection.length>0">
          <button class="btn btn-blue" v-if="$store.getters.getCurrentPage !== $store.getters.getNumberOfPages" @click="loadNextSingleConcepts()">load More</button>
        </div>
    </div>


    <!-- user creatd playList section -->
    <div class="row text-alignment content-holder">
      <h6 v-if="$store.getters.getUserPlaylists !== null && $store.getters.getUserPlaylists.length > 0  " class="main-title col-12">My Playlists</h6>
    </div>
    <!-- {{$store.getters.getUserPlaylists}} -->
    <div class="row playlist-padding">
      <div :class="['col-md-3 ' + index]" v-for="(playlist,index) in $store.getters.getUserPlaylists" :key="playlist.plId" v-on:click="getIndex(index, playlist.items.length)" :style="{ order: index }">
          <!-- playList cards -->
          <div  :v-scroll-to ="playlist.items.length == 0 ? '':'#playAdd'"   class="card-design" v-b-toggle="playlist.plId" @click="getPlaylistById(playlist.plId)">
              <!-- playList thumbnail -->
              <div class="card-design__img" v-lazy-container="{ selector: 'img' }">
                <img  :data-src="makePathForPlaylistCard(playlist)" :src="makePathForPlaylistCard(playlist)" alt="">
              </div>
              <!-- playList Text Based info , delete btn -->
              <div class="card-design__data">
                <h3 v-b-tooltip.hover :title="playlist.plName"  class="card-design__data-heading text-truncate">{{playlist.plName}}</h3>
                <div class="row justify-content-end">
                  <!-- display no of concepts -->
                  <div class="col">
                    <p class="card-design__data-cost" v-if="(playlist.items.length<=1)">{{playlist.items.length}}  {{$t('playlist.Concept')}}</p>
                    <p class="card-design__data-cost" v-else>{{playlist.items.length}}  {{$t('playlist.Concepts')}}</p>
                  </div>
                  <!-- delete playList btn -->
                  <div class="col-3">
                    <button :title="$t('playlist.DeletePlaylist')" @click.stop="deletePlaylist(playlist.plId, playlist.plName)" class="btn btn-danger trash"><span class="mdi mdi-delete"></span></button>
                  </div>
                </div>
              </div>

              <!-- btns for content viewer -->
              <!-- resumePlaying -->
              <div class="text-center button-spacing" v-if="checkIsVisited(index)">
                <b-link class="btn btn-green-o" @click.stop="goToContentViewer(playlist)">{{$t('playlist.ResumePlaying')}}</b-link>
              </div>
              <!-- play (playList contains single LO)-->
              <div class="text-center button-spacing" v-else-if="playlist.items.length == 1">
                <b-link class="btn btn-green-o" @click.stop="goToContentViewer(playlist)">{{$t('common.labels.PLAY')}}</b-link>
              </div>
              <!-- play all (playList contains multiple LO) -->
              <div class="text-center button-spacing" v-else-if="playlist.items.length > 1">
                <b-link class="btn btn-green-o" @click.stop="goToContentViewer(playlist)">{{$t('common.labels.PLAY_ALL')}}</b-link>
              </div>
   
          
            <div v-else class="message">
              {{$t('playlist.labels.Add_Item_To_Playlist')}}
            </div>
          </div>
          <!-- arrowTip -->
          <div v-show="showArrow && (getCurrentPlaylistId == playlist.plId)" class="arrow-top" ></div>
      </div>
      <!-- individual playList item container -->
      <div id="playAdd"  class="row playlist-lo" >
        <div class="col-12">
          <!-- <b-collapse  v-for="playlist in $store.getters.getUserPlaylists"  :key="playlist.plId" :id="playlist.plId" :visible="getCurrentPlaylistId == playlist.plId"> -->
          <b-collapse  v-for="playlist in $store.getters.getUserPlaylists"  :key="playlist.plId" :id="playlist.plId" :visible="showArrow">
            <div v-if="playlist.items !== null && playlist.items.length > 0" class="swiper-holder">
              <swiper :options="swiperOptionp5">
                <!-- <div v-for="(playlist) in $store.getters.getUserPlaylists" :key="playlist.plId"> -->
                <swiper-slide v-for="item in playlist.items" :key="item.itemId">
                  <div class="card-design" v-b-toggle.playlistlo>
                    <div class="card-design__img" v-lazy-container="{ selector: 'img' }">
                      <img :data-src="getItemThumbnailFromEnrolledLO(item)" alt="">
                    </div>
                    <div class="card-design__data">
                      <!-- title -->
                      <h3 v-b-tooltip.hover :title="item.itemName" class="card-design__data-heading no-line text-truncate">{{item.itemName}}</h3>
                      <!-- rating -->
                      <div class="ratingText" v-if="instanceName !=='MAHADEMY'">Overall Rating</div>
                      <div class="rating-ptag" v-if="instanceName !=='MAHADEMY'">
                        <span>
                          <star-rating :rating="item.itemRating" :read-only=true v-bind:increment="0.5"  v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                          </star-rating>
                        </span>
                      </div>
                    </div>
                    <div class="row justify-content-center button-spacing">
                      <div class="col">
                         <button @click.stop="playLO(item)" class='btn btn-green-o'>{{$t('common.labels.PLAY_NOW')}}</button>
                      </div>
                      <div class="col-auto">
                        <button @click="deleteItem(playlist.plId,item)" class="btn btn-danger"><span class="mdi mdi-delete"></span></button>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  

    <b-modal id="addplay" ref="addPlayModalRef" hide-footer hide-header :title="$t('playlist.AddToPlaylist')" class="text-left">
      <div class="social d-block">
        <div class="sub-title">{{$t('playlist.CreateNewPlaylist')}}</div>
        <div class="input-group">
          <span class="input-group-addon" id="newplay">
            <i class="mdi mdi-music"></i>
          </span>
          <input autofocus = true ref="playListInputTitle" type="text" v-on:change="show()" v-on:keyup.enter="check" class="form-control" v-model="PlayList.plName" :placeholder="$t('playlist.placeholders.NameYourPlaylist')" aria-describedby="newplay" v-bind:disabled="selectedPlaylists.length > 0 ? true : false">
          <!-- <input type="text" class="form-control"  v-model="PlayList.plName" :placeholder="$t('playlist.placeholders.NameYourPlaylist')" aria-describedby="newplay" v-bind:disabled="selectedPlaylists.length == 0 ? false : true"> -->
        </div>
      </div>
      
      <div v-if="userPlayLists.length > 0" class="d-block mb-3">
        <h5>{{$t('playlist.labels.OR')}}</h5>
        <div class="sub-title">{{$t('playlist.labels.AddToExistingPlaylists')}}</div>
        <div  v-bar>

          <b-form-group>
            <b-form-checkbox-group stacked v-model="selectedPlaylists" name="flavour2" :options="selectPlayListOptions">
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <!-- <div class="showmore d-flex"><a href="#">Show more</a></div> -->
      </div>

      <b-btn id="addItem" block class="btn btn-large btn-green-o" v-if="PlayList.plName != ''" @click.stop="check()">{{$t('playlist.AddToPlaylist')}}</b-btn>
      <b-btn block class="btn btn-large btn-purple" v-else @click.stop="CheckItemAdd()">{{$t('playlist.AddToPlaylist')}}</b-btn>
      
    </b-modal>
    <b-modal id="createnew" ref="createNewModalRef" hide-footer hide-header :title="$t('playlist.CreateNewPlaylist')" class="text-left">
      <div>
        <!-- <span>Create new playlist!</span> -->
        <div class=" p-0">
          <div class="input-group">
            <input autofocus = true type="text" class="form-control" ref="playListInputBox" v-model="PlayList.plName" v-on:keyup.enter="checkCreate" :placeholder="$t('playlist.placeholders.TypeNewPlaylistNameHere')">
          </div>
        </div>
      </div>
      <b-btn block class="btn btn-large btn-purple" @click.stop="checkCreate()">{{$t('playlist.CreatePlaylist')}}</b-btn>
    </b-modal>


  </div>
</template>
<script>
import { CDP_CDN_THUMBNAIL_URL, INSTANCE_NAME } from '@/components/common/constants.js'
import StarRating from 'vue-star-rating'
import Vue from 'vue'
var _ = require('lodash')
export default {
  name: 'playlistCards',
  components: {
    StarRating
  },
  data () {
    return {
      instanceName: INSTANCE_NAME,
      keyWord: '',
      index: '',
      isOpen: false,
      showArrow: false,
      prevIndex: -1,
      isAccordianVisible: false,
      checkFlag: false,
      flag: false,
      isPresent: false,
      rating: 0.0,
      isActive: false,
      notNextTick: true,
      selectedPlaylists: [], // Must be an array reference!
      selectedCollection: null,
      currentPlaylist: {},
      resultData: [],
      options: [
        { text: 'Playlist 1', value: 'Playlist 1' },
        { text: 'Playlist 2', value: 'Playlist 2' },
        { text: 'Playlist 3', value: 'Playlist 3' },
        { text: 'Playlist 4', value: 'Playlist 4' },
        { text: 'Playlist 5', value: 'Playlist 5' },
        { text: 'Playlist 6', value: 'Playlist 6' }
      ],
      swiperOptionpy: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 'auto',
        // slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      },
      swiperOptionp3: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 'auto',
        // slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      },
      swiperOptionp5: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 'auto',
        // slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      },
      PlayList: {
        plId: '',
        plName: '',
        profileId: '',
        items: []
      },
      UserDetails: {
        profileId: '',
        plId: '',
        itemId: ''
      },
      profileId: this.$store.getters.getProfileDetails.profileId
    }
  },
  computed: {
    getCurrentPlaylistId () {
      if (this.currentPlaylist.plId !== undefined && this.currentPlaylist.plId !== null) {
        return this.currentPlaylist.plId
      } else {
        return '0'
      }
    },
    selectPlayListOptions () {
      var options = []
      var playList = this.$store.getters.getUserPlaylists
      if (playList !== null && playList.length > 0) {
        // playList.forEach(playlist => {
        _.forEach(playList, function (playlist) {
          var obj = {}
          obj.value = playlist.plId
          obj.text = playlist.plName
          options.push(obj)
        })
      }
      return options
    },
    userPlayLists () {
      return this.$store.getters.getUserPlaylists
    },
    purchaseList () {
      return this.$store.getters.getItemsEnrolledByType('LO')
      /* var purchaseList = []
      for (let i = 0; i < this.$store.getters.getCourseEnrolled.length; i++) {
        if (this.$store.getters.getCourseEnrolled[i].courseType === 'LO') {
          purchaseList.push(this.$store.getters.getCourseEnrolled[i])
        }
      }
      return purchaseList
      */
    }
  },
  created () {
    this.fetchCollection()
    this.getPurchasedItems()
    this.getPlaylistLOData()
    // this.$store.dispatch('fetchEnrolledCourses', this.profileId)
  },
  watch: {
    keyWord (oldValue, newValue) {
      // console.log(oldValue)
      if (oldValue.length === 0) {
        this.$store.dispatch('fetchUserSingleConceptCollection', {'profileId': this.$store.getters.getProfileDetails.profileId, 'pageNo': 1})
      }
    }
  },
  methods: {
    // searchSingleConcept
    searchSingleConcept () {
      if (this.keyWord.length !== 0) {
      } else {
        this.$store.dispatch('getSingleConceptSearchResult', {'profileId': this.$store.getters.getProfileDetails.profileId})
        this.$toasted.error('Please enter keyword to search')
      }
    },
    // loadNextSingleConcepts
    loadNextSingleConcepts () {
      this.$store.dispatch('fetchUserSingleConceptCollection', {'profileId': this.$store.getters.getProfileDetails.profileId, 'pageNo': this.$store.getters.getCurrentPage + 1})
    },
    setRating: function (rating) {
      this.rating = rating
    },
    showRating (contentID) {
      this.$store.dispatch('showRating', {'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentID, 'rating': this.rating}).then(response => {
        this.$toasted.success(this.$t('common.alerts.RATING_ADDED'))
      }, error => {
        this.$toasted.error(error)
        console.log('error in adding rating', error)
      })
    },
    toggleAccordianVisibility () {
      if (this.isAccordianVisible) {
        this.isAccordianVisible = false
      } else {
        this.isAccordianVisible = true
      }
    },
    makePath (path, type) {
      if (path !== undefined && path !== null && path.length !== 0) {
        return CDP_CDN_THUMBNAIL_URL + '/' + path
        // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
      } else {
        if (type === 'CO') {
          return '../../../static/assets/images/defaultCO.jpg'
        } else if (type === 'LO') {
          return '../../../static/assets/images/defaultLO.jpg'
        } else {
          return '../../../static/assets/images/defaultLO.jpg'
        }
      }
    },
    makePathForPlaylistCard (playlist) {
      if (playlist.items.length > 0) {
        return this.getItemThumbnailFromEnrolledLO(playlist.items[0])
      } else {
        return '../../../static/assets/images/defaultLO.jpg'
      }
    },
    getPlaylistById (plId) {
      this.currentPlaylist = this.$store.getters.getPlaylist(plId)
    },
    checkValue (val) {
      if (val !== undefined || val === '') {
        if (val.length === 0) {
          return false
        } else {
          return true
        }
      }
    },
    checkIsVisited (index) {
      if (this.$store.getters.getUserPlaylists[index].items.length !== 0) {
        for (var j = 0; j < this.$store.getters.getUserPlaylists[index].items.length; j++) {
          if (this.$store.getters.getUserPlaylists[index].items[j].status !== undefined) {
            if (this.$store.getters.getUserPlaylists[index].items[j].status.isVisited) {
              return true
            }
          }
        }
        return false
      }
    },
    checkCreate () {
      if (this.PlayList.plName === '') {
        this.$toasted.error(this.$t('playlist.alerts.ENTER_PLAYLIST_NAME'), { theme: 'primary', duration: 800 })
        return
      }
      if (!this.isExist()) {
        this.createPlaylist()
      } else {
        this.$toasted.error(this.PlayList.plName + '\n' + this.$t('playlist.alerts.PLAYLIST_ALREADY_PRESENT'), { theme: 'primary', duration: 800 })
      }
    },
    getPurchasedItems () {
      window.axios
        .post('/r/viewCourseEnrolledData', { profileId: this.$store.getters.getProfileDetails.profileId })
        .then(response => {
          this.resultData = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showAddPlayModal () {
      this.$refs.addPlayModalRef.show()
    },
    hideAddPlayModal () {
      this.$refs.addPlayModalRef.hide()
    },
    showCreateNewModal () {
      var self = this
      this.$refs.createNewModalRef.show()
      Vue.nextTick()
        .then(function () {
          self.$refs.playListInputBox.focus()
        })
      // console.log(this.$refs.playListInputBox)
      // this.$refs.playListInputBox.focus()
    },
    hideCreateNewModal () {
      this.$refs.createNewModalRef.hide()
    },
    check () {
      if (this.PlayList.plName === '') {
        this.$toasted.error(this.$t('playlist.alerts.ENTER_PLAYLIST_NAME'), { theme: 'primary', duration: 800 })
        return
      }
      if (!this.isExist()) {
        this.createPlaylist().then(res => {
          this.selectedPlaylists.push(res.plId)
          this.addInPlayListStore()
          this.$toasted.success(this.selectedCollection.title + '\n' + this.$t('playlist.alerts.ADDED_INTO_PLAYLIST') + res.plName, { theme: 'primary', duration: 6000 })
        })
        return
      } else {
        this.$toasted.error(this.PlayList.plName + '\n' + this.$t('playlist.alerts.PLAYLIST_ALREADY_PRESENT'), { theme: 'primary', duration: 800 })
      }
    },
    isExist () {
      for (var i = 0; i < this.$store.getters.getUserPlaylists.length; i++) {
        if (this.$store.getters.getUserPlaylists[i].plName.toUpperCase().replace(/[^a-zA-Z0-9\s]/g, '') === this.PlayList.plName.toUpperCase().replace(/[^a-zA-Z0-9\s]/g, '')) {
          return true
        }
      }
      return false
    },
    CheckItemAdd () {
      if (this.selectedPlaylists.length === 0) {
        this.$toasted.error(this.$t('playlist.alerts.SELECT_PLAYLIST'), { theme: 'primary', duration: 800 })
        return
      } else {
        // For Already exists item
        for (var i = 0; i < this.selectedPlaylists.length; i++) {
          for (var j = 0; j < this.$store.getters.getUserPlaylists.length; j++) {
            this.isPresent = false
            if (this.selectedPlaylists[i] === this.$store.getters.getUserPlaylists[j].plId) {
              for (var k = 0; k < this.$store.getters.getUserPlaylists[j].items.length; k++) {
                if (this.$store.getters.getUserPlaylists[j].items[k].itemId === this.selectedCollection.contentId) {
                  this.isPresent = true
                  // this.$toasted.error(this.selectedCollection.title + '\n' + this.$t('playlist.alerts.PRESENT_IN_PLAYLIST') + this.$store.getters.getUserPlaylists[j].plName, { theme: 'primary', duration: 6000 })
                  break
                } else {
                  this.isPresent = false
                  // this.$toasted.success(this.selectedCollection.title + '\n' + 'added into ' + this.$store.getters.getUserPlaylists[j].plName, { theme: 'primary', duration: 6000 })
                }
              }
              //  return isPresent
              if (this.isPresent === true) {
                this.$toasted.error(this.selectedCollection.title + '\n' + this.$t('playlist.alerts.PRESENT_IN_PLAYLIST') + this.$store.getters.getUserPlaylists[j].plName, {
                  theme: 'primary',
                  duration: 6000
                })
                break
              } else {
                this.$toasted.success(this.selectedCollection.title + '\n' + this.$t('playlist.alerts.ADDED_INTO_PLAYLIST') + this.$store.getters.getUserPlaylists[j].plName, {
                  theme: 'primary',
                  duration: 6000
                })
              }
            }
          }
        }
        this.addInPlayListStore()
        this.selectedPlaylists = []
        this.selectedPlaylists = ''
      }
    },
    addInPlayListStore () {
      var playlistView = this
      // this.selectedPlaylists.forEach(function (playListId) {
      _.forEach(this.selectedPlaylists, function (playListId) {
        var obj = {}
        obj.plId = playListId
        var item = {}
        item.itemId = playlistView.selectedCollection.contentId
        item.itemDescription = playlistView.selectedCollection.description
        item.itemName = playlistView.selectedCollection.title
        item.itemType = playlistView.selectedCollection.type
        obj.item = item
        playlistView.AddToPlayListDB(playListId, item)
        // playlistView.$store.dispatch('addItemInPlaylist', obj)
        // .then(res => {
        //   playlistView.AddToPlayListDB(playListId, item.itemName)
        // })
      })
      this.selectedPlaylists = []
      this.hideAddPlayModal()
    },
    selectCollection (collection) {
      var self = this
      this.selectedPlaylists = []
      this.PlayList.plName = ''
      this.selectedCollection = collection
      this.$refs.addPlayModalRef.show()
      Vue.nextTick()
        .then(function () {
          self.$refs.playListInputTitle.focus()
        })
    },
    fetchCollection: function () {
      var playlistView = this
      window.axios
        .get('r/viewCollection')
        .then(response => {
          playlistView.$store.commit('setCollectionList', response.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    createPlaylist: function () {
      return new Promise(resolve => {
        var PlayListdata = {
          plName: this.PlayList.plName,
          profileId: this.$store.getters.getProfileDetails.profileId,
          items: []
        }
        this.$store
          .dispatch('createPlaylist', PlayListdata)
          .then(res => {
            this.$toasted.success(this.PlayList.plName + '\n' + this.$t('playlist.alerts.PLAYLIST_CREATED'), { theme: 'primary', duration: 800 })
            this.PlayList.plName = ''
            this.hideAddPlayModal()
            this.hideCreateNewModal()
            resolve(res)
          })
          .catch(err => {
            this.$.error(err, { theme: 'primary', duration: 800 })
          })
      })
    },
    AddToPlayListDB: function (playlistId, item) {
      var playlistObj = this.$store.getters.getPlaylist(playlistId)
      playlistObj.items.push(item)
      var url = 'r/updatePlayList'
      window.axios
        .post(url, playlistObj)
        .then(response => {
          this.$store.commit('updatePlaylistItems', response.data)
          // this.$toasted.success(item.itemName + '\n' + this.$t('playlist.alerts.ADDED_INTO_PLAYLIST') + playlistObj.plName, { theme: 'primary', duration: 800 })
        })
        .catch(err => {
          console.log(err)
        })
    },
    deleteItem: function (plId, itemsData) {
      this.UserDetails.profileId = this.$store.getters.getProfileDetails.profileId
      this.UserDetails.plId = plId
      this.UserDetails.itemId = itemsData.itemId
      // sweet alert added by Kumargauravs for confirmation of delete item
      this.$swal({
        title: this.$t('playlist.alerts.REMOVAL_CONFIRMATION'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.$store.dispatch('removePlayListFromDb', this.UserDetails)
          this.$toasted.success(itemsData.itemName + '\n' + this.$t('playlist.alerts.DELETE_ITEM'), { theme: 'primary', duration: 800 })
          this.selectedPlaylists = []
          this.selectedPlaylists = ''
        }
      })
    },
    deletePlaylist: function (plId, plname) {
      var PlayListdata = {
        profileId: this.$store.getters.getProfileDetails.profileId,
        plId: plId,
        plName: plname
      }
      this.$swal({
        title: this.$t('playlist.alerts.PLAYLIST_DELETE_CONFIRMATION'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.$store.dispatch('daletePlaylist', PlayListdata)
          this.$toasted.error(plname + '\n' + this.$t('playlist.alerts.DELETE_PLAYLIST'), { theme: 'primary', duration: 800 })
          this.selectedPlaylists = []
          this.selectedPlaylists = ''
          this.PlayList.plName = ''
        }
      })
      // window.axios
      //   .post('o/createPlayList/' + this.$store.getters.getProfileDetails.profileId, PlayListdata)
      //   .then(response => {
      //     console.log('data===' + response.data)
      //     this.$store.dispatch('setUserPlayLists', response.data)
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
    },
    goToContentViewer (playList) {
      var LOData = []
      LOData.push(playList)
      window.axios
        .post('r/learningobject/getlodatabyplaylist', LOData)
        .then(response => {
          this.$store.dispatch('setCurrentContentViewerPlaylist', response.data)
          if (response.data.length > 0) {
            this.contentPath = response.data[0].path[0].filePath
            this.$store.dispatch('setCurrentPlayingContent', response.data[0])
            this.$store.dispatch('setCurrentPlaylist', playList).then(response => {
              this.$store.dispatch('setIsPlaylist', true).then(response => {
                this.$router.push('/frames')
              })
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    playLO (value) {
      if (this.$store.getters.getLOObjectByItemId(value.itemId).type === 'LO') {
        var playlist = []
        playlist.push(this.$store.getters.getLOObjectByItemId(value.itemId))
        this.$store.dispatch('setCurrentContentViewerPlaylist', playlist).then(response => {
          this.$store.dispatch('setIsPlaylist', false).then(response => {
            this.$router.push('/frames')
          })
        })
      } else {
        this.$toasted.error('This is course')
      }
    },
    getItemName (item) {
      for (var i = 0; i < this.$store.getters.getCollectionList.length; i++) {
        if (this.$store.getters.getCollectionList[i].contentId === item.itemId) {
          return this.$store.getters.getCollectionList[i].title
        }
      }
    },
    getItemNameFromEnrolledLO (item) {
      // alert(123)
      for (var i = 0; i < this.$store.getters.getItemsEnrolledByType('LO').length; i++) {
        if (this.$store.getters.getItemsEnrolledByType('LO')[i].contentId === item.itemId) {
          return this.$store.getters.getItemsEnrolledByType('LO')[i].title
        }
      }
      /* for (var i = 0; i < this.$store.getters.getCourseEnrolled.length; i++) {
        if (this.$store.getters.getCourseEnrolled[i].contentId === item.itemId && this.$store.getters.getCourseEnrolled[i].courseType === 'LO') {
          return this.$store.getters.getCourseEnrolled[i].title
        }
      } */
    },
    getItemRating (item) {
      for (var i = 0; i < this.$store.getters.getCollectionList.length; i++) {
        if (this.$store.getters.getCollectionList[i].contentId === item.itemId) {
          return this.$store.getters.getCollectionList[i].rating
        }
      }
    },
    getItemDuration (item) {
      var TotalDuration = 0
      var LastViewedDuration = 0
      for (var i = 0; i < this.$store.getters.getCollectionList.length; i++) {
        if (this.$store.getters.getCollectionList[i].contentId === item.itemId) {
          TotalDuration = this.$store.getters.getCollectionList[i].duration
          // console.log('total time', TotalDuration)
        }
      }
      LastViewedDuration = this.$store.getters.getLastViewedDurationbyContentId(item.itemId)
      // alert(TotalDuration)
      var PercentRemaining = 100
      if (TotalDuration !== 0) {
        var RemainingTime = TotalDuration - LastViewedDuration
        PercentRemaining = RemainingTime / TotalDuration * 100
      }
      // var PercentRemainingMsg = PercentRemaining + '% remaining'
      return PercentRemaining
    },
    getItemThumbnailFromLO (item) {
      for (var i = 0; i < this.$store.getters.getCollectionList.length; i++) {
        if (this.$store.getters.getCollectionList[i].contentId === item.itemId) {
          return this.$store.getters.getCollectionList[i].thumbnail
        }
      }
    },
    getItemThumbnailFromEnrolledLO (item) {
      var thumbnailPath = '../../../static/assets/images/defaultLO.jpg'
      if (item !== undefined && item !== null) {
        for (var i = 0; i < this.$store.getters.getItemsEnrolledByType('LO').length; i++) {
          if (this.$store.getters.getItemsEnrolledByType('LO')[i].contentId === item.itemId) {
            var thumbnail = this.$store.getters.getItemsEnrolledByType('LO')[i].thumbnail
            if (thumbnail !== undefined && thumbnail !== null && thumbnail.length !== 0) {
              thumbnailPath = CDP_CDN_THUMBNAIL_URL + '/' + this.$store.getters.getItemsEnrolledByType('LO')[i].thumbnail
            }
          }
        }
        /* for (var i = 0; i < this.$store.getters.getCourseEnrolled.length; i++) {
          if (this.$store.getters.getCourseEnrolled[i].contentId === item.itemId && this.$store.getters.getCourseEnrolled[i].courseType === 'LO') {
            var thumbnail = this.$store.getters.getCourseEnrolled[i].thumbnail
            if (thumbnail !== undefined && thumbnail !== null && thumbnail.length !== 0) {
              thumbnailPath = CDP_CDN_THUMBNAIL_URL + '/' + this.$store.getters.getCourseEnrolled[i].thumbnail
            }
          }
        } */
      }
      return thumbnailPath
    },
    getPlaylistLOData () {
      window.axios.post('r/learningobject/getlodatabyplaylist', this.$store.getters.getUserPlaylists).then(response => {
        this.$store.dispatch('setLOMasterDataByPlaylist', response.data)
      })
    },
    addToCart (id) {
      this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(
        response => {
          this.$toasted.success(this.$t('common.alerts.CART_ADDED_SUCCESS'))
        },
        error => {
          console.log('error in adding item to cart', error)
        }
      )
    },
    show () {},
    getIndex (index, itemLength) {
      if (itemLength > 0) {
        if (this.prevIndex === index) {
          if (this.showArrow === false) {
            this.showArrow = true
          } else {
            this.showArrow = false
          }
        } else {
          this.showArrow = true
          this.prevIndex = index
        }
        if (index <= 3) {
          document.getElementById('playAdd').style.order = '3'
        } else if (index > 3 && index <= 7) {
          document.getElementById('playAdd').style.order = '7'
        } else if (index > 7 && index <= 11) {
          document.getElementById('playAdd').style.order = '11'
        } else if (index > 11 && index <= 15) {
          document.getElementById('playAdd').style.order = '15'
        } else if (index > 15 && index <= 19) {
          document.getElementById('playAdd').style.order = '19'
        } else {
          document.getElementById('playAdd').style.order = '100'
        }
      } else {
        this.showArrow = false
      }
    }
  }
}
</script>

<style lang="scss" scopped>
@import '../../../static/assets/styles/scss/variables.scss';

.playlist-cards {
  margin-top: 50px;
  .main-title {
    padding-bottom: 10px;
  }
  .noticemsg{
    padding-left:22px;
  }
  .linkcss {
    color: #777;
  }
 .arrow-top {
    width: 0;
    height: 0;
    margin-left: 45%;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid #ddd;
  }

  .playlist-padding,
  .playlist-lo {
    padding-top: 10px;
    .button-spacing {
      margin:10px 10px 20px 10px;
    }
  }
  .btn-padding {
    padding-top: 20px;
  }

  .playlist-padding{
    .card-design{cursor:pointer;}
    
    position: relative;
    .message{
      margin: 5px 20px 18px 20px;
      color:#999;
      line-height: 20px;
    }
    &:__position{margin-bottom:10px; position: relative;}
  }

  .playlist-lo {
    padding: 0px;
    margin-top: 0px;
    margin-left: 15px;
    margin-right: 15px;
    background-color: #ddd;
    border-radius: 3px;
    margin-bottom: 50px;
    position: relative;
    // overflow-x:hidden;
  &:before{
    content: '';
    overflow:hidden;
    min-width:100vw;
     background-color: #ddd;
     position: absolute;
     overflow:hidden;
     left: 50%;
     margin-left:-50vw;
     width:100%; height:100%;
    
  }

    .swiper-holder .swiper-container{
    padding: 22px 38px;
    
}
    .col-12 {
      padding: 0px auto;
      margin: -1px;

    }
    /*transition: 0.5s all ease;*/
    .card-design {
      background-color: #fff;
      margin-top: 20px;
    }
  }
  .noticemsg-alt {
    input {
      outline: none;
      box-shadow: none;
      border: 1px solid #ddd;
      padding: 15px;
    }
  }
  .progress-css {
    font-size: 12px;
    .progress-bar {
      height: 1rem;
      color: #fff;
      background-color: #9bc42b;
    }
  }
  .removeplay {
    text-align: right;
    color: #555;
  }

  //modal css for create new/ add to playlist
  #addplay {
    margin-top: 1%;
    h5 {
      text-align: center;
    }
    .modal-title {
      font-size: 14px;
      font-weight: 600;
      color: #777;
    }
    .modal-content {
      padding: 25px;
    }
    .sub-title {
      font-size: 14px;
      font-weight: 600;
    }
    .custom-controls-stacked {
      padding-top: 5px;
    }
    .custom-control-description {
      margin-right: 10px;
      font-weight: 400;
      color: #555;
      font-size: 14px;
    }
    .custom-control-indicator {
      position: absolute;
      top: 0.25rem;
      left: 0;
      display: block;
      width: 1rem;
      height: 1rem;
      background-color: #ddd;
      border: none;
      box-shadow: none;
    }
    .custom-control-input:checked ~ .custom-control-description {
      color: #333;
    }
    .custom-control-input:checked ~ .custom-control-indicator {
      color: #fff;
      background-color: #333;
    }
    .input-group {
      box-shadow: none;
      border-radius: 4px;
      margin: 10px auto;
      input {
        font-size: 14px;
        font-weight: 400;
      }
    }
    .form-control {
      box-shadow: none;
      border: none;
      background-color: #efefef;
      padding: 15px;
    }
    .input-group-addon {
      .fa-lock {
        font-size: 18px;
        margin-right: -2px;
      }
      .mdi-envelope {
        font-size: 13px;
        margin-right: -3px;
      }
      background-color: #efefef;
      border: none;
      color: #555;
      border-right: 0px;
      .mdi-music {
        padding-left: 10px;
        padding-top: 15px;
        color:#495057;
        // margin-bottom:-100px;
        display: block;
        font-size:16px;
      }
    }
    .showmore {
      margin: -15px auto 20px auto;
      font-size: 12px;
      a {
        color: #777;
      }
    }
  }
  .createnew {
    position: relative;
    padding-bottom: 22px;
  }
  #createnew {
    margin-top: 5%;
    h5 {
      text-align: center;
    }
    .modal-title {
      font-size: 14px;
      font-weight: 600;
      color: #777;
    }
    .modal-content {
      padding: 25px;
    }
    .sub-title {
      font-size: 14px;
      font-weight: 600;
    }

    .input-group {
      box-shadow: none;
      border-radius: 4px;
      margin: 10px auto;
      input {
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 10px;
      }
    }
    .form-control {
      box-shadow: none;
      border: none;
      background-color: #efefef;
      padding: 15px;
    }
  }

.playlist-holder {
  height: 200px;
}
.playlist-name {
  background: #fff;
  box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.18);
  padding: 10px;
  h5 {
    font-size: 16px;
    margin: 0;
    color: #333;
  }
  .del-pl {
    cursor: pointer;
    font-size: 20px;
  }
}
.search-cards-alt.playlist {
  padding: 0;
  .btn-sm {
    padding: 3px 20px;
    font-size: 11px;
  }
}

#playAdd {width: 100%; order: 100;}

@media screen and (max-width:500px) {
  .text-alignment{
    text-align: center;
  }
}

@media screen and (min-width:501px) {
  .text-alignment{
    text-align: left;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/playList/playlistCards.vue?779ff296